<template>
  <div class="">

    <div class="row">
      <h3 class="col-12">مقادیر ساعت</h3>
      <div class="col">
        <label>زمان هر نوبت</label>
        <input type="number" min="1" pattern="\d+" v-model="reservationRule.base.reset_time" class="form-control">
      </div>
      <div class="col">
        <label>فاصله بین هر نوبت</label>
        <input type="number" pattern="\d+" v-model="reservationRule.base.time_between_each_reservation"
               class="form-control">
      </div>
    </div>

    <hour-reservation-work-times class="my-4" :reservation="reservation"/>


  </div>
</template>

<script>
import HourReservationWorkTimes from "./WorkTimes/HourReservationWorkTimes.vue";

export default {
  name: "HourConfigInputs",
  components: {HourReservationWorkTimes},
  props: {
    reservation: {}
  },
  computed: {
    reservationRule() {
      return this.reservation.reservationRule
    }
  }
}
</script>

<style scoped>

</style>